import { promptChainApi } from '@/services/promptChainApi';
import { executionPolling } from '@/utils/pollingService';
import { docReadinessRun } from '@rm-ui/levelling/docReadinessRun';

/**
 * JD readiness check (PD-1250).
 *
 * The runner moved to `shared/ui/src/levelling/docReadinessRun.js` so rm-portal and
 * rm-portal-beta fire the same chain the same way and produce identical verdicts —
 * matching the scoring rubric, which was already shared in `docReadiness.js`. This
 * wrapper keeps the existing `useDocReadinessCheck()` import path and name, and
 * injects this portal's prompt-chain client and polling service.
 *
 * See the shared module for the full contract; the returned shape is unchanged
 * ({ error, readinessScore, factorResults, hasResult, running, summary, run, reset }).
 */
export function useDocReadinessCheck() {
  return docReadinessRun({ promptChainApi, executionPolling });
}
